import http from '@/utils/axiosProxy.js'


export const getAuthUrl = (sessionId) => http.get('/app/jbh/getAuthUrl', {sessionId})

export const checkLoginStatus = (sessionId) => http.get('/app/jbh/checkLoginStatus', {sessionId})

export const getUserInfo = () => http.get('/app/jbh/userinfo', {})

export const getPkgs = () => http.get('/app/jbh/getPkgs', {})

export const getCategory = () => http.get('/app/jbh/getCategory', {})

export const getDataListByCategoryId = (categoryId, title, page, pageSize) => http.get('/app/jbh/getDataListByCategoryId', {categoryId, title, page, pageSize})

export const downloadSource = (params) => http.post('/app/jbh/downloadSource', params)

export const createOrder = (params) => http.post('/app/jbh/createOrder', params)

export const queryOrderStatus = (orderId) => http.get('/app/jbh/queryOrderStatus', {orderId})

// 客户端版本相关接口
export const getLatestClientVersion = () => http.get('/app/version/latest', {})

export const downloadVersion = (params) => http.post('/app/version/downloadVersion', params)

export const createTryOrder = (activationCode) => http.get('/app/jbh/createTryOrder', {activationCode})